import { render, staticRenderFns } from "./DropdownShare.vue?vue&type=template&id=3f3d0948&lang=true&"
import script from "./DropdownShare.vue?vue&type=script&lang=js&"
export * from "./DropdownShare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports